<div class="row">
  <div *ngIf="labelName" class="col-md-4 col-12">
    <label class="control-label" for="{{ labelName ? labelName : 'email' }}">
      <span [ngClass]="required ? 'required' : ''">*</span>
      {{ labelName }}
    </label>
  </div>
  <div [ngClass]="{ 'col-md-8 col-12': labelName, 'col-12': !labelName }">
    <input
      (blur)="emitBlur()"
      (keypress)="onKeyPress($event)"
      (ngModelChange)="changeModel($event)"
      [ngClass]="{
        requiredField: !isValid && !submitted,
        errorRequiredField: !isValid && submitted,
      }"
      [ngModel]="inputModel"
      autocomplete="email"
      class="form-control minEmail"
      id="{{ labelName ? labelName : 'email' }}"
      maxlength="320"
      name="email"
      placeholder="email@domain.com"
      type="text"
    />
  </div>
  <pre *ngIf="environment?.useDebugMode">
    inputModel: {{ inputModel }}
    isValid {{ isValid }}
  </pre>
  <div
    *ngIf="submitted && !isValid"
    class="col-12 errorText text-start"
    id="validationError"
  >
    <i class="fa fa-circle-o fa-lg circle-position"></i>
    <i class="fa fa-exclamation exclamation-position"></i>
    <p class="col ps-2 ms-4 input-validation-text">
      Enter a valid email address.
    </p>
  </div>
  <div *ngIf="!submitted || isValid" class="col-12">
    <p></p>
  </div>
</div>
